import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { SocFormData } from 'components/Assessments/SocAssessment/types/SocFormData'
import { SocFormField } from 'components/Assessments/SocAssessment/types/SocFormField'
import { DischargePlanningQuestionnaireItem } from './questionnaire'

/**
 * Discharge Planning subsection adapter for SOC Assessment
 * Handles discharge planning extraction and transformation
 */
export class DischargePlanningAdapter extends BaseSubsectionAdapter<SocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<SocFormData> {
    const dischargePlans = getAnswerValuesFromItems(
      [flatAnswers[DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_DISCHARGE_PLANS]],
      DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_DISCHARGE_PLANS
    )?.at(0)
    const rehabilitationPotential = getAnswerValuesFromItems(
      [flatAnswers[DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL]],
      DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL
    )?.at(0)
    const notes = getAnswerValuesFromItems(
      [flatAnswers[DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_NOTES]],
      DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_NOTES
    )?.at(0)
    return {
      [SocFormField.DISCHARGE_PLANNING_DISCHARGE_PLANS]: dischargePlans,
      [SocFormField.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL]: rehabilitationPotential,
      [SocFormField.DISCHARGE_PLANNING_NOTES]: notes
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(SocFormField.DISCHARGE_PLANNING_DISCHARGE_PLANS)) {
      mutations.push({
        linkId: DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_DISCHARGE_PLANS,
        value: this.getFormDataField(SocFormField.DISCHARGE_PLANNING_DISCHARGE_PLANS)
      })
    }

    if (this.formDataFieldExists(SocFormField.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL)) {
      mutations.push({
        linkId: DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL,
        value: this.getFormDataField(SocFormField.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL)
      })
    }

    if (this.formDataFieldExists(SocFormField.DISCHARGE_PLANNING_NOTES)) {
      mutations.push({
        linkId: DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_NOTES,
        value: this.getFormDataField(SocFormField.DISCHARGE_PLANNING_NOTES)
      })
    }

    return mutations
  }
}
